const accountSelector = {
  label: "Selecione uma conta",
};

export default accountSelector;
